<template>
  <b-container>
    <Breadcrumbs crumbString="Products,Mountings,Bulletin Boards"></Breadcrumbs>
    <b-row>
      <b-col class="col-12 col-md-4 col-lg-4">
        <h2>{{ title }}</h2>
        <div>Information bulletin boards and cases</div><br>
        <div>Examples of a variety of bulletin board options and cases.</div>
        <div><b-btn class="mt-3" @click="createEstimateFromPage">Create an Estimate</b-btn></div>
      </b-col>
      <b-col class="col-12 col-md-8 col-lg-8">
        <b-container class="pods-container">
          <b-row>
            <b-col class="col-12 col-md-7 col-lg-7 image-pod">
              <div class="img bulletin-img"
                   v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/bulletin-boards/custom-bulletin-case.jpg') + ')'}"></div>
            </b-col>
            <b-col class="col-12 col-md-5 col-lg-5 image-pod">
              <div class="img bulletin-85-img"
                   v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/bulletin-boards/bulletin-case.jpg') + ')'}"></div>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="col-12 col-md-6 col-lg-6 image-pod">
              <div class="img bulletin-75-img"
                   v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/bulletin-boards/powder-coated-aluminum-bulletin-board.jpg') + ')'}"></div>
            </b-col>
            <b-col class="col-12 col-md-3 col-lg-3 image-pod">
              <div class="img bulletin-155-img"
                   v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/bulletin-boards/bulletin-case-with-upright-posts.jpg') + ')'}"></div>
            </b-col>
            <b-col class="col-12 col-md-3 col-lg-3 image-pod">
              <div class="img bulletin-155-img"
                   v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/bulletin-boards/low-profile-bulletin-case.jpg') + ')'}"></div>
            </b-col>
          </b-row>
        </b-container>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import Breadcrumbs from '@/components/Breadcrumbs.vue'
  import { createEstimateFromPage } from '@/mixins/createEstimateFromPage'

  export default {
    components: {
      Breadcrumbs
    },
    mixins: [ createEstimateFromPage ],
    data () {
      return {
        title: 'Bulletin Boards & Cases'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/products/BulletinBoards.vue